import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ProtectedRoute, PublicOnlyRoute } from "./routes/ProtectedRoute";
import { Header, Footer } from "./components/Layout";
import { BottomNav } from "./components/BottomNav";
import { PWAInstallBanner } from "./components/PWAInstallBanner";
import { NotifyPermissionPrompt } from "./components/NotifyPermissionPrompt";
import HomePage from "./pages/HomePage";
import PropertiesPage from "./pages/PropertiesPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import FavoritesPage from "./pages/FavoritesPage";
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage } from "./pages/AuthPages";
import { DashboardHome } from "./pages/DashboardPages";
import { PropertyWizard } from "./pages/PropertyWizard";
import { LeadCenter } from "./pages/LeadCenter";
import { AccountSettings } from "./pages/AccountSettings";
import { AgentPublicProfile } from "./pages/AgentPublicProfile";
import { AnalyticsDashboard } from "./pages/AnalyticsDashboard";
import { AgencyPage } from "./pages/AgencyPage";
import { AgencyPublicPage } from "./pages/AgencyPublicPage";
import { CommercialAdvisor } from "./pages/CommercialAdvisor";
import { AdminUsersPage } from "./pages/AdminUsersPage";

const Layout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
    <PWAInstallBanner />
    <NotifyPermissionPrompt />
    <BottomNav />
  </>
);

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors theme="dark" />
          <div className="App">
            <Routes>
              <Route path="/" element={<Layout><HomePage /></Layout>} />
              <Route path="/propiedades" element={<Layout><PropertiesPage /></Layout>} />
              <Route path="/propiedades/:id" element={<Layout><PropertyDetailPage /></Layout>} />
              <Route path="/favoritos" element={<Layout><FavoritesPage /></Layout>} />
              <Route path="/asesor/:slug" element={<Layout><AgentPublicProfile /></Layout>} />
              <Route path="/agencia/:slug" element={<Layout><AgencyPublicPage /></Layout>} />
              <Route path="/login" element={<Layout><PublicOnlyRoute><LoginPage /></PublicOnlyRoute></Layout>} />
              <Route path="/registro" element={<Layout><PublicOnlyRoute><RegisterPage /></PublicOnlyRoute></Layout>} />
              <Route path="/olvide-mi-password" element={<Layout><PublicOnlyRoute><ForgotPasswordPage /></PublicOnlyRoute></Layout>} />
              <Route path="/reset-password" element={<Layout><PublicOnlyRoute><ResetPasswordPage /></PublicOnlyRoute></Layout>} />
              <Route
                path="/dashboard"
                element={<Layout><ProtectedRoute><DashboardHome /></ProtectedRoute></Layout>}
              />
              <Route
                path="/dashboard/leads"
                element={<Layout><ProtectedRoute><LeadCenter /></ProtectedRoute></Layout>}
              />
              <Route
                path="/dashboard/analytics"
                element={<Layout><ProtectedRoute><AnalyticsDashboard /></ProtectedRoute></Layout>}
              />
              <Route
                path="/dashboard/agencia"
                element={<Layout><ProtectedRoute><AgencyPage /></ProtectedRoute></Layout>}
              />
              <Route
                path="/dashboard/agencia/analytics"
                element={<Layout><ProtectedRoute><AnalyticsDashboard scope="agency" /></ProtectedRoute></Layout>}
              />
              <Route
                path="/dashboard/advisor"
                element={<Layout><ProtectedRoute><CommercialAdvisor /></ProtectedRoute></Layout>}
              />
              <Route
                path="/dashboard/cuenta"
                element={<Layout><ProtectedRoute><AccountSettings /></ProtectedRoute></Layout>}
              />
              <Route
                path="/dashboard/nueva"
                element={<Layout><ProtectedRoute><PropertyWizard mode="create" /></ProtectedRoute></Layout>}
              />
              <Route
                path="/dashboard/editar/:id"
                element={<Layout><ProtectedRoute><PropertyWizard mode="edit" /></ProtectedRoute></Layout>}
              />
              <Route
                path="/dashboard/admin/usuarios"
                element={<Layout><ProtectedRoute allowedRoles={["admin"]}><AdminUsersPage /></ProtectedRoute></Layout>}
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
